import React, { memo } from 'react';
import { useFragment, graphql } from 'react-relay';
import { IconCell } from '../../icon-cell/IconCell.tsx';
import type { IssueTypeCell$key } from './__generated__/IssueTypeCell.graphql';

type Props = {
	fieldRef: IssueTypeCell$key;
};

export const IssueTypeCell = memo(({ fieldRef }: Props) => {
	const data = useFragment<IssueTypeCell$key>(
		graphql`
			fragment IssueTypeCell on JiraIssueTypeField {
				...IconCell
			}
		`,
		fieldRef,
	);

	return <IconCell fragmentRef={data} showErrorIconWhenEmpty />;
});
